import _indexOf from './_indexOf.js';

export default function _includes(a, list) {
  return _indexOf(list, a, 0) >= 0;
}


//////////////////
// WEBPACK FOOTER
// ./~/ramda/es/internal/_includes.js
// module id = 308
// module chunks = 2